import { TemplateLookup } from '../../../models/TemplateLibrary'
import { InputParametersHierarchyContext } from '../../../store/ai/inputParametersHierarchy'
import { calculateLevel } from './utils'
import { InputParameterHierarchyType } from '../../../components/InputParameterHierarchy/model'

export enum TemplateTrackingDetailsWhere {
  TemplateLibrary = 'TemplateLibrary',
  InContext = 'InContext',
}

export enum TemplateCreationMethod {
  AiGenerated = 'aiGenerated',
  Manual = 'manual',
}

export enum TemplateGeneratorSource {
  GenerateTemplate = 'generateTemplate',
  TemplateAIChat = 'templateAIChat',
}

type TemplateLibraryTrackingDetails = {
  templateId: string
  type: string
  typeId: string
  where: TemplateTrackingDetailsWhere
}

export type TemplateInContextTrackingDetails = TemplateLibraryTrackingDetails & {
  level?: string | null
}

export const getTemplateLibraryTrackingDetails = (template: Pick<TemplateLookup, 'id' | 'type' | 'typeId'>): TemplateLibraryTrackingDetails => {
  return {
    templateId: template.id,
    type: template.type,
    typeId: template.typeId,
    where: TemplateTrackingDetailsWhere.TemplateLibrary,
  }
}

export const getInContextTrackingDetails = (
  templateId: string,
  type: InputParameterHierarchyType,
  typeId: string,
  context: InputParametersHierarchyContext,
): TemplateInContextTrackingDetails => {
  return {
    templateId,
    type,
    typeId,
    level: context.level || calculateLevel(type, context),
    where: TemplateTrackingDetailsWhere.InContext,
  }
}
